import type { ContactPreferenceChannelIcon } from '@shared/config';
import { ChatTyping, Email, MailOpen, Mobile, Phone } from '@shared/icons';
import type { ReactNode } from 'react';

const CHANNEL_ICON_COMPONENTS: Record<ContactPreferenceChannelIcon, () => ReactNode> = {
  Email: () => <Email />,
  ChatTyping: () => <ChatTyping />,
  Mobile: () => <Mobile />,
  Phone: () => <Phone />,
  MailOpen: () => <MailOpen />,
};

function renderChannelIcon(icon: ContactPreferenceChannelIcon): ReactNode {
  return CHANNEL_ICON_COMPONENTS[icon]();
}

export { renderChannelIcon };
